"use strict";
var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function(key) {
    key._reactInternalInstance = void 0;
  },
  get: function(key) {
    return key._reactInternalInstance;
  },
  has: function(key) {
    return key._reactInternalInstance !== void 0;
  },
  set: function(key, value) {
    key._reactInternalInstance = value;
  }
};
module.exports = ReactInstanceMap;
